import graphql__38d57a5d9ae7265fa97d from "./__generated__/SignOutMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__38d57a5d9ae7265fa97d;

function signOut(onCompleted) {
  return commitMutation(appRelayEnvironment, {
    mutation,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { signOut };
